import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import isNil from 'lodash/isNil';

import { FILTERS_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';
import {
  EArbitrageFilters,
  ECexPairFilters,
  EDexPairFilters,
  EGeneralFilters,
  EProjectFilters,
  ESolPairFilters,
  IFilters,
} from 'types/filters';
import { ICexPair, IDexPair } from 'types/pairs';

import { getProjectFiltersKey } from '../utils';

interface IPayload {
  cex?: {
    pair?: ICexPair;
    type: ECexPairFilters;
  };
  dex?: {
    pair?: IDexPair;
    type: EDexPairFilters;
  };
  sol?: {
    pair?: IDexPair;
    type: ESolPairFilters;
  };
  general?: EGeneralFilters;
  arbitrage?: EArbitrageFilters;
  project?: {
    projectId: number;
    type: EProjectFilters;
  };
}

export const saveFiltersReducer: CaseReducer<IFilters, PayloadAction<IPayload>> = (
  state,
  { payload },
) => {
  const { dex, cex, sol, general, arbitrage, project } = payload;

  if (general) {
    const filters = (state[general]!.filters ?? []).filter(el => el.value !== undefined);

    if (state[general]) {
      state[general] = {
        filters: filters,
        setted: filters,
      };
    }

    LocalStorage.set(FILTERS_CACHE_KEY, state);

    return;
  }

  if (arbitrage) {
    const filters = (state.arbitrage[arbitrage]!.filters ?? []).filter(
      el => el.value !== undefined,
    );

    if (state.arbitrage[arbitrage]) {
      state.arbitrage[arbitrage] = {
        filters: filters,
        setted: filters,
      };
    }

    LocalStorage.set(FILTERS_CACHE_KEY, state);

    return;
  }

  if (project) {
    const key = getProjectFiltersKey(project.projectId, project.type);
    const projectEntry = state.project[key];

    if (!projectEntry) return;

    const filters = projectEntry.filters.filter(el => el.value !== undefined);

    state.project[key] = {
      updated_at: new Date(Date.now()).toISOString(),
      filters,
      setted: filters,
    };

    LocalStorage.set(FILTERS_CACHE_KEY, state);
    return;
  }

  const key = dex ? 'dex' : cex ? 'cex' : 'sol';
  const pairId = dex ? dex.pair?.id : cex ? cex.pair?.id : sol ? sol.pair?.id : undefined;
  const type = dex ? dex.type : cex ? cex.type : sol ? sol.type : undefined;

  if (isNil(pairId) || isNil(type) || !state[key][pairId]) return;

  //@ts-ignore
  const filterTypeEntry = state[key][pairId]!.filters[type];
  const filters = (filterTypeEntry?.filters ?? []).filter(
    //@ts-ignore
    el => el.value !== undefined,
  );

  state[key][pairId]!.updated_at = new Date(Date.now()).toISOString();
  state[key][pairId]!.filters = {
    ...state[key][pairId]!.filters,
    [type]: {
      filters: filters,
      setted: filters,
    },
  };

  LocalStorage.set(FILTERS_CACHE_KEY, state);
};
